import { AssessmentsMenuBase } from "@/ui-components/layouts/components/AssessmentsMenu/AssessmentsMenuBase";

const linkGenerator = (assessmentId: string, siteAssessmentId: string, id: string) =>
  `/assessments/${assessmentId}/${siteAssessmentId}/${id}`;

export const AssessmentsMenu = ({ mode }: { mode: "data_provider" | "verifier" }) => (
  <AssessmentsMenuBase linkGenerator={linkGenerator} mode={mode} />
);
